import type { PartDefinition } from '@rogue/rackbuilder'
import { FOAM_PLYO } from '../../modelPaths'
import type { BuyRequest, IRogue } from '@/js/services/RogueTypes'

export class PlyoboxBuilder {
  constructor(private rogue: IRogue, private buyRequest: BuyRequest) {}

  public build(): { part: PartDefinition, config: { height: number } } {
    const boxes: number[] = []

    this.buyRequest.children?.forEach(child => {
      const product = this.rogue.getProductById(child.productId)

      if (!product) {
        return
      }

      for (let i = 0; i < child.qty && i <= 3; i += 1) {
        if (product.name.includes('3-Set')) {
          boxes.push(...[6, 12, 24])
        } else if (product.name.includes('Full Set')) {
          boxes.push(...[6, 12, 20, 24])
        } else {
          const size = parseInt(product.name, 10)
          if (!Number.isNaN(size)) {
            boxes.push(size)
          }
        }
      }
    })

    if (!boxes.length) {
      boxes.push(...[24, 20, 12, 6])
    }

    // Sort by largest to smallest
    boxes.sort((a, b) => b - a)

    const base: PartDefinition = {
      mesh  : `${FOAM_PLYO}#foam ${boxes[0]}`,
      slots : {},
    }

    let part = base

    const flaps: PartDefinition = { mesh: `${FOAM_PLYO}#flaps`, slots: {} }

    for (let i = 1; i < boxes.length; i += 1) {
      const newPart = {
        mesh  : `${FOAM_PLYO}#foam ${boxes[i]}`,
        slots : {},
      }
      part.slots = { top: [newPart, flaps] }
      part = newPart
    }

    return { part: base, config: { height: boxes.reduce((val, boxSize) => boxSize + val, 0) } }
  }
}
